import { adobeCleanObject, analytics, channelType, customerType, formName, globalState } from "mfe-lib-bfo-shared";

export const triggerAnalytics = (formMessage: string, language: string) => {
    const payload = adobeCleanObject({
        page: {
            pageInfo: {
                pageUrl: window.location.pathname,
                language: language,
                //day: getDayShort(getNow(), "en-US"),
            },
        },
        application: {
            productName: globalState.get().adobeCurrentProductName,
            formName: formName(globalState.get().adobeCurrentPage),
            formSection: globalState.get().adobeCurrentPage,
            // appID: appID,
            formMessage: formMessage,
            channelType: channelType(),
        },
        user: {
            customerType: customerType(globalState.get().adobeCurrentProductName),
        },
    });
    analytics.trackEvent("error-popup", payload);
};
